import React, { useState, useRef } from "react";
import "./Home.css";
import DashboardView from "../DashboardView";
import { Button, Dropdown } from "antd";
import { PlusOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";

import StatIcon1 from "../../assets/icons/folder.svg";
import StatIcon2 from "../../assets/icons/stat-icon3.svg";
import StatIcon3 from "../../assets/icons/dashboard.svg";
import DashboardReport from "../../assets/icons/grid.svg";
import DashboardGrid from "../../assets/icons/dashboard-report.svg";
import DashboardCardEye from "../../assets/icons/dashboard-eye.svg";
import DashboardIcon from "../../assets/icons/grid.svg";
import GroupIcon from "../../assets/icons/folder-plus.svg";
import ResourceIcon from "../../assets/icons/database.svg";

import DataSourceDonut from "./Charts/DataSourceChart";
import ScheduledReportsOverview from "./ScheduledReportsOverview/ScheduledReports";
import SelectItemsTable from "./SelectItemTable/SelectItemTable";

export default function Home({ onAddGroup, onAddResource, onAddDashboard }) {
  const sliderRef = useRef(null);
  const [isCreateMenuOpen, setIsCreateMenuOpen] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const dashboardStats = [
    {
      statName: "Total Groups Created",
      amount: 120,
      icon: StatIcon1,
      bgColor: "#FFFBEB",
      iconBgColor: "#FEF3C7",
      borderColor: "#FEF3C7",
    },
    {
      statName: "Total Resources Added",
      amount: 120,
      icon: StatIcon2,
      bgColor: "#ECFDF5",
      iconBgColor: "#D1FAE5",
      borderColor: "#D1FAE5",
    },
    {
      statName: "Total Reports/Dashboards",
      amount: 120,
      icon: StatIcon3,
      bgColor: "#F0F9FF",
      iconBgColor: "#E0F2FE",
      borderColor: "#E0F2FE",
    },
  ];

  const dashboardCards = [
    {
      id: 1,
      title: "Executive Overview",
      icon: DashboardReport,
      views: "200",
      timestamp: "Today, 9:30 AM",
      isActive: true,
    },
    {
      id: 2,
      title: "Sales Pipeline Q2",
      icon: DashboardGrid,
      views: "250",
      timestamp: "Yesterday, 4:15 PM",
      isActive: true,
    },
    {
      id: 3,
      title: "Inventory Status",
      icon: DashboardGrid,
      views: "350",
      timestamp: "Jan 14, 2:00 PM",
      isActive: true,
    },
    {
      id: 4,
      title: "User Analytics",
      icon: DashboardReport,
      views: "300",
      timestamp: "Jan 12, 11:30 AM",
      isActive: false,
    },
    {
      id: 5,
      title: "Revenue Breakdown ",
      views: "210",
      icon: DashboardGrid,
      timestamp: "Jan 10, 9:00 AM",
      isActive: true,
    },
    {
      id: 6,
      title: "Dashboard6",
      icon: DashboardReport,
      views: "210",
      timestamp: "Jan 10, 9:00 AM",
      isActive: false,
    },
  ];

  const dataSourceData = [
    { name: "REST API", value: 45, color: "#1E3A5F" },
    { name: "MySQL", value: 30, color: "#F59E0B" },
    { name: "GraphQL", value: 15, color: "#94A3B8" },
    { name: "MongoDB", value: 10, color: "#2DD4BF" },
  ];

  const scheduledReportsData = [
    {
      id: 1,
      date: new Date(2025, 9, 1), // October 1, 2025
      time: "09:00 AM",
      title: "Weekly Sales Report",
      type: "report",
      icon: "📊",
      iconBg: "#d1fae5",
      iconColor: "#059669",
    },
    {
      id: 2,
      date: new Date(2025, 9, 1), // October 1, 2025
      time: "11:00 AM",
      title: "Kickoff Meeting",
      type: "meeting",
      icon: "👥",
      iconBg: "#dbeafe",
      iconColor: "#2563eb",
    },
    {
      id: 3,
      date: new Date(2025, 9, 3), // October 3, 2025
      time: "02:30 PM",
      title: "Client Presentation",
      type: "presentation",
      icon: "📊",
      iconBg: "#fed7aa",
      iconColor: "#ea580c",
    },
    {
      id: 4,
      date: new Date(2025, 9, 5),
      time: "10:00 AM",
      title: "Quarterly Review",
      type: "report",
      icon: "📈",
      iconBg: "#fce7f3",
      iconColor: "#db2777",
    },
    {
      id: 5,
      date: new Date(2025, 9, 7),
      time: "03:00 PM",
      title: "Product Demo",
      type: "demo",
      icon: "🎯",
      iconBg: "#e0e7ff",
      iconColor: "#6366f1",
    },
    {
      id: 6,
      date: new Date(2025, 9, 10),
      time: "11:00 AM",
      title: "Budget Planning",
      type: "meeting",
      icon: "💰",
      iconBg: "#fef3c7",
      iconColor: "#f59e0b",
    },
    {
      id: 7,
      date: new Date(2025, 9, 12),
      time: "09:30 AM",
      title: "Marketing Strategy",
      type: "presentation",
      icon: "🎨",
      iconBg: "#fecdd3",
      iconColor: "#f43f5e",
    },
    {
      id: 8,
      date: new Date(2025, 9, 12),
      time: "01:00 PM",
      title: "Performance Analysis",
      type: "report",
      icon: "📉",
      iconBg: "#d1fae5",
      iconColor: "#059669",
    },
    {
      id: 9,
      date: new Date(2025, 9, 15),
      time: "08:00 AM",
      title: "Sprint Planning",
      type: "meeting",
      icon: "⚡",
      iconBg: "#dbeafe",
      iconColor: "#2563eb",
    },
    {
      id: 10,
      date: new Date(2025, 9, 15),
      time: "11:30 AM",
      title: "Customer Feedback Review",
      type: "review",
      icon: "💬",
      iconBg: "#e0e7ff",
      iconColor: "#6366f1",
    },
  ];

  const dashboardItems = [
    {
      id: 1,
      name: "Dashboard A",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 2,
      name: "Dashboard B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 3,
      name: "Report A",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 4,
      name: "Report B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 5,
      name: "Report B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 6,
      name: "Report B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 7,
      name: "Report B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
  ];

  const handleScroll = () => {
    const el = sliderRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 1);
  };
  const handleAddGroup = () => {
    setIsCreateMenuOpen(false);
    if (onAddGroup) onAddGroup();
  };

  const handleAddResource = () => {
    setIsCreateMenuOpen(false);
    if (onAddResource) onAddResource();
  };

  const handleAddDashboard = () => {
    setIsCreateMenuOpen(false);
    if (onAddDashboard) onAddDashboard("dashboard"); // or "reports" based on selection
  };

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -280, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 280, behavior: "smooth" });
    }
  };

  const createMenuItems = [
    { key: "dashboard", label: "Dashboard / Report", icon: DashboardIcon, onClick: handleAddDashboard },
    { key: "resource", label: "Resource", icon: ResourceIcon, onClick: handleAddResource },
    { key: "group", label: "Group", icon: GroupIcon, onClick: handleAddGroup },
  ];

  const addNewMenu = (
    <div className="create-menu">
      <div className="create-menu-title">Create</div>
      {createMenuItems.map((item) => (
        <div key={item.key} className="create-menu-item" onClick={item.onClick}>
          <span className={`create-menu-icon create-menu-icon--${item.key}`}>
            <i style={{ WebkitMaskImage: `url(${item.icon})`, maskImage: `url(${item.icon})` }} />
          </span>
          <span className="create-menu-label">{item.label}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div className="dashboard-container">
      <div className="dashboard-header-container">
        <h2>Home</h2>
        <div>
          <Dropdown
            overlay={addNewMenu}
            trigger={["click"]}
            placement="bottomRight"
            visible={isCreateMenuOpen}
            onVisibleChange={setIsCreateMenuOpen}
            overlayClassName="create-menu-overlay"
          >
            <Button type="primary" className="add-new-btn">
              <PlusOutlined /> Create New
            </Button>
          </Dropdown>
        </div>
      </div>

      <div className="dashboard-stats">
        {dashboardStats.map((stat, index) => (
          <div
            key={index}
            className="stat-container"
            style={{ backgroundColor: stat.bgColor, border: `1px solid ${stat.borderColor}` }}
          >
            <div className="stat-content">
              <div className="stat-text">
                <h3 className="stat-name">{stat.statName}</h3>
                <div className="stat-amount">{stat.amount}</div>
              </div>
              <div className="stat-icon" style={{ backgroundColor: stat.iconBgColor }}>
                <img src={stat.icon} alt="stat icon" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Most Used Dashboard Section */}
      <div className="dashboard-slider-section">
        <h3 className="slider-title">Most Used Dashboards</h3>

        <div className="slider-wrapper">
          {canScrollLeft && (
            <button className="slider-btn left" onClick={scrollLeft}>
              <LeftOutlined />
            </button>
          )}

          <div className="dashboard-cards-container" ref={sliderRef} onScroll={handleScroll}>
            {dashboardCards.map((card) => (
              <div key={card.id} className="dashboard-card">
                <div className="card-content">
                  <div className="card-info">
                    <div className="flex-center">
                      <div className={`dashboard-status ${!card.isActive ? "dashboard-inactive" : ""}`} />
                      <div className="card-title">{card.title}</div>
                    </div>
                    <div className="card-icon">
                      <img src={card.icon} alt={card.title} />
                    </div>
                  </div>
                  <div className="card-info">
                    <p className="card-description">{card.timestamp}</p>
                    <div>
                      <img src={DashboardCardEye} className="dashboard-card-eye" alt="eye" />
                      <span>{card.views}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {canScrollRight && (
            <button className="slider-btn right" onClick={scrollRight}>
              <RightOutlined />
            </button>
          )}
        </div>
      </div>

      {/* Chart Section */}
      <div className="dashboard-chart-section">
        <div className="data-source-usage">
          <div className="data-source-usage-header">
            <h3>Data Source Usage</h3>
            <p>Details</p>
          </div>
          <DataSourceDonut dataSourceData={dataSourceData} />
        </div>

        <div className="data-overview-usage">
          {/* Select itemsSection */}
          <SelectItemsTable />
        </div>
      </div>

      <div className="data-overview-usage">
        <ScheduledReportsOverview scheduledReportsData={scheduledReportsData} />
      </div>
    </div>
  );
}
